import { RouteConfig } from 'vue-router';
import Login from '@/views/auth/Login.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import ChangePassword from '@/views/auth/ChangePassword.vue';
import Register from '@/views/auth/Register.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'login',
		component: Login,
		meta: {
			guest: true,
		},
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			guest: true,
		},
	},
	{
		path: '/resetpassword',
		name: 'resetpassword',
		component: ResetPassword,
		meta: {
			guest: true,
		},
	},
	{
		path: '/changepassword',
		name: 'changepassword',
		component: ChangePassword,
		meta: {
			guest: true,
		},
	},
	{
		path: '/register',
		name: 'register',
		component: Register,
	},
];

export default routes;
